<!-- FOOTER -->
<footer class="footer">
  <div class="container-fluid">
    <nav class="float-left">
      <ul>
        <li>
          <a href="javascript:void(0)" data-toggle="modal" data-target="#contactus">
            {{'contact_us' | translate}}
          </a>
        </li>
        <li>
          <a href="javascript:void(0)" data-toggle="modal" data-target="#aboutus">
            {{'about' | translate}}
          </a>
        </li>
      </ul>
    </nav>
    <div class="copyright float-right text-white">
      &copy;
      <script>
          document.write(new Date().getFullYear())
      </script>, made with <i class="material-icons">favorite</i> by  Group Akinators for a better web.
    </div>
  </div>
</footer>


<div class="modal fade" id="contactus">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <span class="text-danger" *ngIf="error">{{error}}</span>
      <!-- Modal Header -->
      <div class="modal-header">

        <h5 class="modal-title">Contactez nous</h5>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <div class="container">

          <div class="row">
            <div class="col-lg-6 col-md-6">
              <span class="text-danger" id="contact-subject-error"></span>
              <div class="form-group">
                <input id="subject" type="text" class="form-control" name="subject" placeholder="Objectif" [(ngModel)]="subject" />
              </div>
            </div>

            <div class="col-lg-6 col-md-6">
              <span class="text-danger" id="contact-email-error"></span>
              <div class="form-group">
                <input id="email" type="text" class="form-control" name="email" placeholder="email" [(ngModel)]="email" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class=" col-lg-6 col-md-12 ">
              <span class="text-danger" id="contact-comment-error"></span>
              <div class="form-group ">
                <textarea id="comment" class="form-control" name="comment" placeholder="Your Message..." [(ngModel)]="comment"></textarea>
              </div>
            </div>
          </div>
          <div class="d-flex flex-row justify-content-center ">
            <button type="submit " class="btn btn-primary " (click)="contactUs()"><img src="../../assets/icons/footer/send.png ">Submit</button>
            <!--<input type="submit" (click)="contactUs()" class="btn connexion-button" value="Envoyer">-->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="aboutus">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">

        <h5 class="modal-title">Equipe du Projet</h5>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <div class="team-section text-center my-5 w-97 m-auto" id="team">
          <h2 class="h1-responsive font-weight-bold my-5 text-primary">Development team</h2>
          <p class="grey-text w-responsive mx-auto mb-5">Ce site a été développé par un groupe de 7 étudiants de master qualité du logiciel fes, sous les principes de gestion de projet agile. Travail encadré par Prof Mr Ahmed Azough</p>
          <div class="row" >
            <div class="col-lg-4 col-md-6 mb-lg-0 mb-5" *ngFor="let membre of team">
              <div class="avatar mx-auto">
                <img src="../../assets/pictures/team/{{membre.photo}}" class="rounded-circle z-depth-1 w-50"
                     alt="Photo of {{ membre.name}}">
              </div>
              <h5 class="font-weight-bold mt-4 mb-3">{{membre.name }} : {{membre.age}} ans</h5>
              <p class="text-uppercase text-primary "><strong>{{membre.job}}</strong></p>
              <p class="grey-text">{{membre.rating}}</p>
              <ul class="list-unstyled mb-2">
                <a class="p-2 fa-lg tw-ic" href="{{membre.linkedin}}">
                  <span class="material-icons">link</span>
                </a>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
